import {gql, useMutation} from "@apollo/client";

const UPDATE_REFERRAL_OFFER_DATE_MUTATION = gql`
    mutation updateReferralOfferDate($input: UpdateReferralOfferDateInput!) {
        updateReferralOfferDate(input: $input) {
            id
            guid
            status
            firstServiceDate
        }
    }
`;

export function useUpdateReferralOffer() {
    const [mutate, {loading, error, data}] = useMutation(UPDATE_REFERRAL_OFFER_DATE_MUTATION, {
        refetchQueries: ['ProviderReferralOffersByClientGuid']
    });

    return {
        updateReferralOffer: mutate,
        loading,
        error,
        data
    };
}
